var _slicedToArray = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

exports.validateCenter = function validateCenter(center) {
  var validCenterLengths = [2, 3];

  if (!Array.isArray(center) || !validCenterLengths.includes(center.length)) {
    throw new Error("ERROR! Center has to be an array of length two or three");
  }

  var _center = _slicedToArray(center, 2),
      lng = _center[0],
      lat = _center[1];

  if (typeof lng !== "number" || typeof lat !== "number") {
    throw new Error("ERROR! Longitude and Latitude has to be numbers but where ".concat(typeof lng, " and ").concat(typeof lat));
  }

  if (lng > 180 || lng < -180) {
    throw new Error("ERROR! Longitude has to be between -180 and 180 but was ".concat(lng));
  }

  if (lat > 90 || lat < -90) {
    throw new Error("ERROR! Latitude has to be between -90 and 90 but was ".concat(lat));
  }
};